import ProgressTracker from 'components/elements/symbols/ProgressTracker'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * 画面上部のプログレストラッカー、説明文表示エリア
 */
const ContentHeaderArea: React.FC<ContentHeaderAreaProps> = (props) => {
  return (
    <React.Fragment>
      {props.progress && (
        <StyledProgressTrackerArea>
          <ProgressTracker progress={props.progress} />
        </StyledProgressTrackerArea>
      )}
      <StyledDescriptionArea>
        <Text color="var(--color-text)">{props.description}</Text>
      </StyledDescriptionArea>
    </React.Fragment>
  )
}

export type ContentHeaderAreaProps = {
  progress?: number
  description?: string
}

const StyledProgressTrackerArea = styled.div`
  height: 17px;
  text-align: center;
`

const StyledDescriptionArea = styled.div`
  margin: 16px 20px 0;
`

export default ContentHeaderArea
